import { SelectProps } from '@radix-ui/react-select';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/Select';

interface FormatSelectorProps extends SelectProps {}

export function FormatSelector(props: FormatSelectorProps) {
  const formats = ['csv', 'xlsx'];

  return (
    <Select {...props}>
      <SelectTrigger id="format-selector">
        <SelectValue placeholder="Select format" />
      </SelectTrigger>

      <SelectContent>
        {formats.map((format) => (
          <SelectItem key={format} value={format}>
            {format}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
